export default class GorgiasButtonHandler {
  static adjustPositionDown = (chatButton, chatWindow) => {
    if (chatButton) {
      chatButton.style.bottom = '20px';
    }

    if (chatWindow) {
      chatWindow.style.bottom = '90px';
    }
  };

  static adjustPositionUp = (chatButton, chatWindow) => {
    if (chatButton) {
      chatButton.style.bottom = '64px';
    }
    if (chatWindow) {
      chatWindow.style.bottom = '134px';
    }
  };
}
